import { connect } from 'react-redux';
import { closeModal } from 'redux-core/dialogs/actions';
import { getOpenDialogPayloadSelector, getOpenDialogSelector } from 'redux-core/dialogs/selectors';

const mapStateToProps = (state) => ({
  open: getOpenDialogSelector(state),
  payload: getOpenDialogPayloadSelector(state),
});

const mapDispatchToProps = { closeModal };

export default connect(mapStateToProps, mapDispatchToProps);
